/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Weighings_No_GrowerInputs */

const vi_my_weighings_no_grower = /** @type {(inputs: My_Weighings_No_GrowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản chưa được gắn với hộ trồng chè nào. Liên hệ HTX để được gắn hộ.`)
};

/**

* @param {My_Weighings_No_GrowerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_weighings_no_grower = /** @type {((inputs?: My_Weighings_No_GrowerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Weighings_No_GrowerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_weighings_no_grower(inputs)
});